import { render, staticRenderFns } from "./Formstack.vue?vue&type=template&id=484900ab&"
import script from "./Formstack.vue?vue&type=script&lang=js&"
export * from "./Formstack.vue?vue&type=script&lang=js&"
import style0 from "./Formstack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports